import { render, staticRenderFns } from "./tenderDocumentClarification.vue?vue&type=template&id=bbedd8b0&scoped=true"
import script from "./tenderDocumentClarification.vue?vue&type=script&lang=js"
export * from "./tenderDocumentClarification.vue?vue&type=script&lang=js"
import style0 from "./tenderDocumentClarification.vue?vue&type=style&index=0&id=bbedd8b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbedd8b0",
  null
  
)

export default component.exports